// Product Tiles functions - also, added in theme.js to collection filter calls
function productTiles() {
  const textureButtons = document.querySelectorAll(".product-tile-btn-texture");
  textureButtons.forEach(function (texture, index) {
    texture.addEventListener("click", function (event) {
      event.preventDefault();
      if (this.textContent.trim() === "See Texture") {
        this.textContent = "See Bag";
      } else if (this.textContent.trim() === "See Bag") {
        this.textContent = "See Texture";
      } else if (this.textContent.trim() === "Next Image") {
        this.textContent = "Previous Image";
      } else if (this.textContent.trim() === "Previous Image") {
        this.textContent = "Next Image";
      }

      let photos = this.parentNode
        .querySelector(".photos")
        .querySelectorAll("img");
      photos.forEach(function (elm, index) {
        if (elm.classList.contains("active")) {
          elm.classList.remove("active");
        } else {
          elm.classList.add("active");
        }
      });
    });
  });

  // Close buttons on Product overlay
  const quickAddCloseButtons = document.querySelectorAll(".product-tile-close");
  quickAddCloseButtons.forEach(function (closeBtn, index) {
    closeBtn.addEventListener("click", function (event) {
      event.preventDefault();
      let parent = this.parentNode.parentNode.parentNode;
      let addToCartBtn = parent.querySelector(".add-to-cart.cartbutton");
      if (parent.classList.contains("open")) {
        parent.classList.remove("open");
        addToCartBtn.classList.remove("highlighted");
      }
    });
  });

  // Product Tile Add to Cart buttons
  const addToCartButtons = document.querySelectorAll(".product-tile-btn-add");
  addToCartButtons.forEach(function (addBtn, index) {
    addBtn.addEventListener("click", function (event) {
      event.preventDefault();
      let parent = this.parentNode.parentNode;
      const newNode = document.createElement("div");
      newNode.classList.add("quick-add-prices");
      newNode.innerHTML = "<p></p>";
      if (parent.classList.contains("open")) {
        parent.classList.remove("open");
      } else {
        parent.classList.add("open");
        let addToCartBtn = parent.querySelector(".add-to-cart.cartbutton");
        parent.insertBefore(newNode, addToCartBtn);
      }
    });
  });



  
const quickAddVariantButtons = document.querySelectorAll(
  ".product-tile .variant-input-wrap"
);

quickAddVariantButtons.forEach((varBtn) => {
  const buttonsInHere = varBtn.querySelectorAll(".variant-input");

  buttonsInHere.forEach((btn, index) => {
    const updatePrice = () => {
      const parent = varBtn.closest(".product-tile");

      if (!parent) return;

      const quickAddPrices = parent.querySelectorAll(
        ".quick-add-prices__meta"
      );

      quickAddPrices.forEach((elm, priceIndex) => {
        elm.classList.toggle("active", priceIndex === index);
      });
    };

    btn.addEventListener("focus", updatePrice);
    btn.addEventListener("click", updatePrice);
  });
});


/*
  const quickAddVariantButtons = document.querySelectorAll(
    ".product-tile .variant-input-wrap"
  );
  quickAddVariantButtons.forEach(function (varBtn, index) {
    let buttonsInHere = varBtn.querySelectorAll(".variant-input");
    buttonsInHere.forEach(function (btn, index) {
      btn.addEventListener("focus", function (event) {
        event.preventDefault();
        console.log('safari issue');
        let buttonIndexNum = index;
        let parent = this.parentNode.parentNode.parentNode;
        let quickAddPrices = parent.querySelectorAll(".quick-add-prices__meta");
        quickAddPrices.forEach(function (elm, index) {
          elm.classList.remove("active");
          if (index == buttonIndexNum) {
            elm.classList.add("active");
          }
        });
      });
    });
  });
*/

}

$(document).ready(function () {
  /**
   * PDP Page Bold Subscription Price Logic
   */
  // On load for PDP page, if queried with selling plan, set active class.
  const sellingPlanInQuery = window.location.href.includes("selling_plan");
  if (sellingPlanInQuery) {
    $(".pc-pdp-button").removeClass("active");
    $(".pc-pdp-button--subscribe")
      .addClass("active")
      .find('input[type="radio"]')
      .prop("checked", true);
  }

  // Run initially on page load. Give time to load.
  if (window.location.pathname.startsWith("/products/")) {
    setTimeout(() => {
      window.BOLD.BsubWidget._renderPrices();
    }, 500);
  }

  // Handle clicking on the one-time-purchase and the subscribe buttons.
  $(".pc-pdp-button").on("click", function () {
    // Execute once.
    if (!$(this).hasClass("active")) {
      $(".pc-pdp-button").removeClass("active");
      $(this).addClass("active");
      $(this)
        .find('input[type="radio"]')
        .prop("checked", true)
        .trigger("change");
      window.BOLD.BsubWidget._renderPrices();
    }
  });

  // Upon switching size variants, trigger price render for new variant.
  $(".product-single__form .variant__button-label").on(
    "click",
    function (event) {
      // Give time for variant to update.
      setTimeout(() => {
        $('.pc-pdp-button.active input[type="radio"]').trigger("change"); // Update URL appropriately if subscribe is selected.
        window.BOLD.BsubWidget._renderPrices();
      }, 100);
    }
  );

  // Upon changing qty via plus and minus buttons, and entering it on change.
  $(".js-qty__wrapper button").on("click", () => {
    window.BOLD.BsubWidget._renderPrices();
  });
  $(".js-qty__num").on("input", () => {
    window.BOLD.BsubWidget._renderPrices();
  });
  /**
   * End Of PDP Page Bold Subscription Price Logic
   */

  // When ajax cart updates, update Free shipping values
  document.addEventListener("cart:updated", function (evt) {
    //This will show cart object: console.log(evt.detail.cart);

    var free_message = "Congrats you get free shipping!";
    var shipping_value = 8500;
    var cart_total = evt.detail.cart.total_price;
    var shipping_value_left = (shipping_value - cart_total) / 100;
    var shipping_percentage = Math.round(
      ((shipping_value - cart_total) / shipping_value) * 100
    );
    var progress_percentage = 100 - shipping_percentage;
    if (progress_percentage > 100) {
      progress_percentage = 100;
      $("#CartDrawer .shipping-savings-message").text(free_message);
      $("#CartDrawer .progress-bar").attr(
        "style",
        "width:100%;background-color:#124762;"
      );
    } else {
      $("#CartDrawer .shipping-savings-message").text(
        "You are $" + shipping_value_left + " away from free shipping."
      );
      $("#CartDrawer .progress-bar").attr(
        "style",
        "width:" + progress_percentage + "%;"
      );
    }
  });

  // Gift Message; click input checkbox to toggle visibility.
  $(".cart-attribute__field.checkbox-this-isa-gift input").on(
    "click",
    function (e) {
      if ($("#gift-message").hasClass("active")) {
        $("#gift-message").removeClass("active");
        $("#gift-note").html("");
      } else {
        $("#gift-message").addClass("active");
        $("#gift-note").html(
          "When we can't meat in person, thank goodness for delivery. Enjoy your gift!"
        );
      }
      //
    }
  );

  // HOME PAGE functions

  // Jerky Boxes
  if ($("#shopify-section-1602195085768").length) {
    if (window.matchMedia("(min-width: 768px)").matches) {
      $(".hero__product-sampler-title").arctext({ radius: 500 });
    }

    $(window).resize(function () {
      if (window.matchMedia("(min-width: 768px)").matches) {
        $(".hero__product-sampler-title").arctext({ radius: 500 });
      }
    });
  }

  // Whats Your Flava section
  if ($("#shopify-section-1601934796092").length) {
    $(".slideshow-custom-nav").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: "#shopify-section-1601934796092 .hero",
      dots: false,
      //centerMode: true,
      focusOnSelect: true,
      //variableWidth: true
      responsive: [
        {
          breakpoint: 480,
          settings: "unslick",
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

    $(".slideshow-custom-nav li").on("click", function () {
      $(".slideshow-custom-nav li").removeClass("slick-current");
      var num = $(this).attr("data-slick-index");
      setTimeout(function () {
        num = parseInt(num) + 1;
        $(".slideshow-custom-nav li:nth-of-type(" + num + ")").addClass(
          "slick-current"
        );
      }, 800);
    });
  }

  // Home page Instagram
  if ($("#shopify-section-1601594276705").length) {
    $("#shopify-section-1601594276705 a").attr("target", "_blank");
  }

  // Our Story - History Timeline
  if ($(".page-block-timeline").length) {
    var timelineSwiper = new Swiper(
      ".page-block-timeline .timeline .swiper-container",
      {
        direction: "vertical",
        loop: false,
        speed: 1600,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            var year = document
              .querySelectorAll(".swiper-slide")
              [index].getAttribute("data-year");
            return '<span class="' + className + '">' + year + "</span>";
            //return '<span class="' + className + '">' + (menu[index]) + '</span>';
          },
        },
        //pagination: '.swiper-pagination',
        //       paginationRender: function (swiper, index, className) {
        //         console.log('here');
        //         var year = document.querySelectorAll('.swiper-slide')[index].getAttribute('data-year');
        //         return '<span class="' + className + '">' + year + '</span>';
        //       },
        //paginationClickable: true,
        //nextButton: '.swiper-button-next',
        //prevButton: '.swiper-button-prev',
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768: {
            direction: "horizontal",
          },
        },
      }
    );
  }

  // Beef Jerky Landing page jump to links
  if ($(".filter-pills").length) {
    $(".filter-pills a").click(function () {
      var scrollElm = $(this).attr("href");
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(scrollElm).offset().top,
        },
        500
      );
    });
  }

  if ($(".template-cart").length) {
    // Use for Giftwrap in the cart.
    // Need to add a class to tell if Gift Wrap product is in cart so can hide Remove button and Quantity.

    if ($('[name="attributes[Gift]"]').is(":checked") == true) {
      $("body").addClass("giftwrap-selected");
    } else {
      $("body").removeClass("giftwrap-selected");
    }
  }

  // Journal pages - to identify those built with Shogun, add a body class
  if ($(".shogun-root").length) {
    $("body").addClass("shogun-template");

    // These are 4 legacy Shogun posts we want to use new theme header banner on
    if (
      window.location.href.indexOf(
        "the-best-non-perishable-food-high-protein-snack"
      ) > 0
    ) {
      $("body").addClass("show-banner");
    }

    if (
      window.location.href.indexOf(
        "guide-to-pemmican-jerky-easy-pemmican-recipe"
      ) > 0
    ) {
      $("body").addClass("show-banner");
    }

    if (
      window.location.href.indexOf(
        "give-a-great-beef-jerky-gift-from-a-distance"
      ) > 0
    ) {
      $("body").addClass("show-banner");
    }

    if (
      window.location.href.indexOf(
        "173698759-keto-friendly-snack-zero-carb-zero-sugar-beef-jerky"
      ) > 0
    ) {
      $("body").addClass("show-banner");
    }
  }

  // Footer social links
  $('.site-footer__linklist a[href^="https://"]').attr("target", "_blank");

  // Jerky Box PDP Carousel
  if ($("#jerky-box-contents").length) {
    $("#jerky-box-contents").slick({
      slidesToShow: 1,
      arrows: true,
      dots: true,
      infinite: false,
    });
  }

  // Adding captions in the blog posts

  $("body.template-article article.article img:not( .no-figure, .promo )").each(
    function () {
      if (!$(this).parent().is("figure")) {
        $(this).wrap(
          $("<figure/>", {
            class: "image",
          })
        );
        var img_alt = $(this).attr("alt");
        if (img_alt) {
          $(this).after($("<figcaption/>").append(img_alt));
        }
      }
    }
  );

  // Anchor tag will not show on focus for iOS.
  const focusLinkEl = document.querySelector(".skip-link");
  focusLinkEl.addEventListener("click", () => {
    window.location.href = "#MainContent";
    const main = document.querySelector("main");
    main.focus();
  });

  // To address tickets PCAA-621 and PCAA-759.
  document.querySelectorAll(".site-nav__link__toggle-submenu").forEach((el) => {
    el.addEventListener("keydown", (e) => {
      // console.log( e.key, e.code );
      if (e.shiftKey && e.key === "Tab") {
        el.setAttribute("aria-expanded", "false");
        el.parentElement.classList.remove("is-focused");
      } else if (["Enter", "Space"].includes(e.code)) {
        e.preventDefault(); // Prevent space from jumping down screen.
        el.setAttribute(
          "aria-expanded",
          el.getAttribute("aria-expanded") === "false" ? "true" : "false"
        ); // Toggle
        el.parentElement.classList.toggle("is-focused");
      }
    });
  });

  // On last item in megamenu, check if tabbed to next main nav item.
  document
    .querySelectorAll(
      ".site-nav__dropdown.megamenu .grid__item:last-child ul li:last-child a"
    )
    .forEach((el) => {
      el.addEventListener("keydown", (e) => {
        if (!e.shiftKey && e.key === "Tab") {
          const parentNavLinkEl = el.closest(".site-nav__item"); // Traverse upwards to find parent megamenu.
          parentNavLinkEl
            .querySelector(".site-nav__link__toggle-submenu")
            .setAttribute("aria-expanded", "false");
          parentNavLinkEl.classList.toggle("is-focused");
        }
      });
    });

  // On last item in footer, if tabbed, open cart and go to the first interactive item.
  document
    .querySelector(".footer .footer-utility ul li:last-child a")
    .addEventListener("keydown", (e) => {
      if (!e.shiftKey && e.key === "Tab") {
        const cartButtonEl = document.querySelector(
          'a[aria-controls="slidecarthq"]'
        );
        cartButtonEl.click();
        setTimeout(() => {
          document.querySelector(".slidecarthq .header h2").focus();
        }, 250);
      }
    });
  // Hacky way of removing slidecart's ability to disable the plus button. This way we can tab to it after the qty input PCAA-166.
  function removeDisabled(inputs) {
    inputs.forEach((input) => {
      input.disabled = false;
      input.removeAttribute("disabled");
      Object.defineProperties(input, {
        disabled: {
          get: function () {
            return false;
          },
        },
        setAttribute: {
          value: function () {},
        },
      });
    });
  }

  // Change mobile search button icon to the black variation, since background is white.
  // Give time for page to load.
  setTimeout(() => {
    const mobileSearchButtonEl = document.querySelector(
      ".cc-mobile-search-icon"
    );
    if (mobileSearchButtonEl !== null) {
      mobileSearchButtonEl.setAttribute(
        "src",
        "https://cdn.convertcart.com/uploads/9ed6fa4f.png"
      );
    }
    removeDisabled(
      document.querySelectorAll(".quantity-selector button:last-child")
    );

    // PCAA-604 These are redundant, remove from being focusable.
    const convertCartImageLinkEls = document.querySelectorAll(".cc-img-sec a");
    convertCartImageLinkEls.forEach((el) => {
      el.setAttribute("tabindex", -1);
    });

    // PCAA-604 shogun links not clickable for some reason, ensure they are here.
    const interactiveLinks = document.querySelectorAll(
      ".shg-product .shg-product-atc-btn-wrapper .shg-btn"
    );
    interactiveLinks.forEach((el) => {
      el.setAttribute("tabindex", 0);
    });
  }, 1000);

  // Whenever we add a product, run this to ensure tabbable qty inputs in cart PCAA-166.
  const addToCartEl = document.querySelector(".add-to-cart");
  addToCartEl &&
    addToCartEl.addEventListener("click", () => {
      setTimeout(() => {
        removeDisabled(
          document.querySelectorAll(".quantity-selector button:last-child")
        );
      }, 1000);
    });

  // Make homepage single banners slick slider text areas readable by voice over.
  /*
  const bannerEls = document.querySelectorAll('.slick-slider[data-slide-count="1"]');
	bannerEls.forEach( bel => {
		const tabbableEls = bel.querySelectorAll('.hero__top-subtitle, .hero__title, .hero__subtitle');
		tabbableEls.forEach( tel => tel.setAttribute('tabindex', 0) )
	} );
  */

  // Our Story - History Timeline
  if ($(".page-block-side-by-side.come-get").length) {
    $(".page-block-side-by-side.come-get .column a").addClass("btn");
  }

  // New Homepage design scripts
  if ($(".photo-hover").length) {
    let navList = document.querySelector(".photo-hover nav ul").children;
    let imgList = document.querySelector(".photo-hover__photos").children;
    let btnList = document.querySelector(".photo-hover__buttons").children;

    for (let li of navList) {
      if ("ontouchstart" in document.documentElement) {
        li.querySelector("a").addEventListener("click", (e) => {
          e.preventDefault();
          for (let img of imgList) {
            img.style.opacity = 0;
          }
          let img = imgList[li.dataset.index];
          img.style.opacity = 1;

          // Set LI to active so colour stays
          for (let bg of navList) {
            bg.querySelector("a").classList.remove("active");
          }
          let bg = navList[li.dataset.index].querySelector("a");
          bg.classList.add("active");

          // Add function to show button
          for (let btn of btnList) {
            btn.classList.remove("active");
          }
          let btn = btnList[li.dataset.index];
          btn.classList.add("active");
        });

        li.querySelector("a").addEventListener("ontouchstart", (e) => {
          e.preventDefault();
          for (let img of imgList) {
            img.style.opacity = 0;
          }
          let img = imgList[li.dataset.index];
          img.style.opacity = 1;

          // Set LI to active so colour stays
          for (let bg of navList) {
            bg.querySelector("a").classList.remove("active");
          }
          let bg = navList[li.dataset.index].querySelector("a");
          bg.classList.add("active");

          // Add function to show button
          for (let btn of btnList) {
            btn.classList.remove("active");
          }
          let btn = btnList[li.dataset.index];
          btn.classList.add("active");
        });
      } else {
        li.addEventListener("mouseenter", (e) => {
          e.preventDefault();
          let img = imgList[li.dataset.index];
          img.style.opacity = 1;
        });
        li.addEventListener("mouseleave", (e) => {
          e.preventDefault();
          let img = imgList[li.dataset.index];
          img.style.opacity = 0;
        });
      }
    }
  }

  // Collection page scripts
  productTiles();

  // Add for Bundler app, when go to Cart page, open slidecart //
  /*
  if ($(".template-cart").length) {
    setTimeout(function() {
      window.SLIDECART_UPDATE()
      window.SLIDECART_OPEN()
    }, 500)    
  }
  */
}); // End of document.ready
